import { z } from "zod";
export const StorybookEntryOrigin = z.object({
    id: z.string(),
    type: z.enum(["story", "docs"]),
    name: z.string(),
    title: z.string(), // Same as 'kind' for v3
    index: z.number().optional(),
});
export const StorybookEntry = z.object({
    id: z.string(),
    storyId: z.string(),
    designSystemId: z.string(),
    sourceId: z.string(),
    aliases: z.array(z.string()).optional(),
    url: z.string(),
    isDeleted: z.boolean().optional(),
    origin: StorybookEntryOrigin,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
